import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-pa-md row items-start q-gutter-md" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-h6 q-mt-sm q-mb-xs" }, [
  /*#__PURE__*/_createTextVNode(" Lista de "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Frequência ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-caption text-grey" }, " Gerencia as frequências dos alunos ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-h6 q-mt-sm q-mb-xs" }, [
  /*#__PURE__*/_createTextVNode(" Ocorrência de"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Alunos ")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-caption text-grey" }, "Verifique as ocorrências dos alunos existentes e cadastre novas", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_card, {
      class: "area-redacao-card",
      flat: "",
      bordered: "",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goTo('lista-de-frequencia')))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card_section, { horizontal: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "col-5 flex flex-center" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_img, {
                  class: "rounded-borders",
                  src: require('../../../assets/nova-redacao.png')
                }, null, 8, ["src"])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, { class: "q-pt-xs" }, {
              default: _withCtx(() => [
                _hoisted_2,
                _hoisted_3
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_q_card, {
      class: "area-redacao-card",
      flat: "",
      bordered: "",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goTo('ocorrencias')))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card_section, { horizontal: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "col-5 flex flex-center" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_img, {
                  class: "rounded-borders",
                  src: require('../../../assets/corrigir-redacao.png')
                }, null, 8, ["src"])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, { class: "q-pt-xs" }, {
              default: _withCtx(() => [
                _hoisted_4,
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}